import { CustomThemeProvider } from './Theme';

export default CustomThemeProvider;
